import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b81d671a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b81d671a')) {
      api.createRecord('b81d671a', component.options)
    } else {
      api.reload('b81d671a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b81d671a&", function () {
      api.rerender('b81d671a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Vybq72QuJ8Ln/JS/comp/FavElement.vue"
export default component.exports